<template>
  <div>
    <div
      class="book"
      :style="{ 'background-color': bgc }"
      :class="{ startBtn: bgc !== '#242B2A' }"
    >
      {{ buttonLabel }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgc: {
      type: String,
      default: '#242B2A'
    },
    buttonLabel: {
      type: String,
      default: 'Start for free'
    }
  }
}
</script>

<style scoped lang="less">
.book {
  margin: 0.4rem 0;
  padding: 0.28rem 0.72rem;
  border-radius: 0.64rem;
  color: #ffffff;
  font-size: 0.4rem;
  font-weight: bold;
  cursor: pointer;
  display: inline-block;
  position: relative;
  &:hover {
    color: #818584;
  }
}
.startBtn {
  &:hover {
    color: #fff;
  }
}
</style>
